const menuItems = {
  items: [
    {
      id: "dashboard",
      // title: "Dashboard",
      type: "group",
      icon: "icon-navigation",
      children: [
        {
          id: "dashboard",
          title: "intelliSales Dashboard",
          type: "single-item",
          icon: "feather icon-home",
          url: "/app/dashboard",
        },
      ],
    },
    {
      id: "partskart-dashboard",
      // title: "Dashboard",
      type: "group",
      icon: "icon-navigation",
      children: [
        {
          id: "partskart-dashboard",
          title: "Partskart Dashboard",
          type: "single-item",
          icon: "feather icon-package",
          url: "/app/partskart-dashboard",
        },
      ],
    },
    // {
    //   id: "landing",
    //   title: "Landing",
    //   type: "group",
    //   icon: "icon-support",
    //   children: [
    //     {
    //       id: "landing-page",
    //       title: "Recommendation Dashboard",
    //       type: "item",
    //       icon: "feather icon-navigation-2",
    //       classes: "nav-item",
    //       url: `${process.env.REACT_APP_RECOMMENDATION_DASHBOARD_URL}`,
    //       target: true,
    //       external: true,
    //     },
    //   ],
    // },
  ],
};

export default menuItems;
